import { render, staticRenderFns } from "./DragVerifyImgChip.vue?vue&type=template&id=f1ea6cb6&scoped=true&"
import script from "./DragVerifyImgChip.vue?vue&type=script&lang=js&"
export * from "./DragVerifyImgChip.vue?vue&type=script&lang=js&"
import style0 from "./DragVerifyImgChip.vue?vue&type=style&index=0&id=f1ea6cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ea6cb6",
  null
  
)

export default component.exports